import React from "react"
import { graphql } from "gatsby"
import { DatoCmsThematicFolder, ThematicFolderCoverFieldsFragment } from "../../../../graphql-types"
import Filter from "./filter/filter"
import * as styles from "./cover.module.scss"

type CoverProps = {
    data: ThematicFolderCoverFieldsFragment
    filterThematicFolders: (filteredThematicFolders: []) => void
    thematicFolders: DatoCmsThematicFolder[]
    filters: Array<string>
}

const Cover: React.FC<CoverProps> = ({
    data,
    filterThematicFolders,
    thematicFolders, 
    filters
}) => {

    return (
      <Filter
        filterThematicFolders={filterThematicFolders}
        thematicFolders={thematicFolders}
        filters={filters}
        allFilterLabel={data.thematicFoldersAllFilterLabel}
      />
    )
}

export const fragment = graphql`
    fragment ThematicFolderCoverFields on DatoCmsThematicFoldersPage {
        thematicFoldersAllFilterLabel
    }
`

export default Cover
